import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import useLocalStorage from '@zenbusiness/application-commons-hooks/useLocalStorage';
import { useNavigate } from 'react-router-dom';

import { RELEASE_TAX_SERVICES_BANNER } from '#client/constants/experimentsFlags';
import { MFE_PATHS } from '#client/constants/paths';
import { TAX_SERVICES_FEATURE_BANNER } from '#client/constants/whatNewBanner';
import useCheckTransactionContext from '#client/hooks/useCheckTransactionContext';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import { useDashboardPath } from '#client/hooks/useDashboardPath';
import useFeatureFlag from '#client/hooks/useFeatureFlag';
import useWhatsNewBannerContext from '#client/hooks/useWhatNewBannerContext';

const TAX_SERVICES_NAME = [
  'tax_annual_filing',
  'tax_annual_filing_prior_year',
  'tax_unlimited_advice'
];

const useTaxServicesBanner = () => {
  const [isTaxServicesBannerEnabled, isLoadingTaxServicesBannerFlag] = useFeatureFlag(
    RELEASE_TAX_SERVICES_BANNER
  );
  const { businessEntityUuid, entitlements } = useConstBusinessEntityUuid();
  const { hasTransaction } = useCheckTransactionContext();
  const path = useDashboardPath(MFE_PATHS.MONEY_TAX_SERVICES);
  const navigate = useNavigate();

  const { removeBanner } = useWhatsNewBannerContext();
  const buttonPressedTracker = useClickstreamCallback('buttonPressed');

  const doesNotHaveTaxServices = !TAX_SERVICES_NAME.some((entitlement) =>
    entitlements.has(entitlement)
  );
  /**
   * Store the whats_new_banner in the local storage to prevent show whats new banner
   */
  const [taxServicesBannerCache, setTaxServicesBannerCache] = useLocalStorage(
    `${TAX_SERVICES_FEATURE_BANNER.type}.${businessEntityUuid}`,
    false
  );

  /**
   * Show the banner if the user is approved, has any transaction, and doesn't have any tax services
   */
  const isShowTaxServicesBanner =
    !isLoadingTaxServicesBannerFlag &&
    isTaxServicesBannerEnabled &&
    !taxServicesBannerCache &&
    doesNotHaveTaxServices &&
    hasTransaction;

  const handleClose = () => {
    removeBanner(TAX_SERVICES_FEATURE_BANNER.type);
    setTaxServicesBannerCache(true);
  };

  const handleGetStarted = () => {
    buttonPressedTracker({
      elementName: 'get_started_tax_banner',
      elementText: 'Get started',
      appPageName: 'active_banking_dashboard',
      appSection: 'banking'
    });
    removeBanner(TAX_SERVICES_FEATURE_BANNER.type);
    setTaxServicesBannerCache(true);
    navigate(path);
  };

  return {
    isShowTaxServicesBanner,
    handleClose,
    handleGetStarted
  };
};

export default useTaxServicesBanner;
